import { Link, useNavigate } from "react-router-dom";
import { LogOut, ShieldCheck, UserRound } from "lucide-react";
import { useT, LANGS } from "../i18n";
import { useAuth } from "../context/AuthContext";

export default function Header() {
  const { t, lang, setLang } = useT();
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <header data-testid="app-header" className="sticky top-0 z-40 backdrop-blur-xl bg-white/80 border-b border-[#0D4045]/10">
      <div className="max-w-6xl mx-auto px-4 md:px-8 h-16 flex items-center justify-between gap-3">
        <Link to="/" data-testid="header-logo-link" className="flex items-center gap-2 shrink-0">
          <img src="/logo.jpg" alt="Lantouraj" data-testid="header-logo-img" className="w-9 h-9 rounded-full object-cover" />
          <span className="font-extrabold text-lg tracking-tight text-[#0D4045]" style={{ fontFamily: "Manrope" }}>
            Lantouraj
          </span>
        </Link>

        <div className="flex items-center gap-2">
          <div data-testid="language-switcher" className="flex items-center rounded-full border border-[#0D4045]/15 bg-white p-0.5">
            {LANGS.map((l) => (
              <button
                key={l.code}
                data-testid={`lang-${l.code}-btn`}
                onClick={() => setLang(l.code)}
                className={`px-2.5 py-1.5 rounded-full text-xs font-semibold uppercase tracking-wide transition-colors duration-200 ${
                  lang === l.code ? "bg-[#0D4045] text-[#FDFBF7]" : "text-[#0D4045]/70 hover:text-[#0D4045]"
                }`}
              >
                {l.code === "gcf" ? "Kr" : l.code}
              </button>
            ))}
          </div>

          {user && user.role === "admin" && (
            <Link to="/admin" data-testid="header-admin-link"
              className="hidden sm:flex items-center gap-1.5 text-sm font-semibold text-[#0D4045] px-3 py-2 rounded-full hover:bg-[#E8F3F1] transition-colors duration-200">
              <ShieldCheck size={16} /> {t("nav.admin")}
            </Link>
          )}
          {user ? (
            <button onClick={async () => { await logout(); navigate("/"); }} data-testid="header-logout-btn"
              className="flex items-center gap-1.5 text-sm font-semibold text-[#0D4045] px-3 py-2 rounded-full hover:bg-[#E8F3F1] transition-colors duration-200">
              <LogOut size={16} /> <span className="hidden sm:inline">{t("nav.logout")}</span>
            </button>
          ) : (
            <Link to="/espace-pro" data-testid="header-pro-login-link"
              className="flex items-center gap-1.5 text-sm font-semibold bg-[#0D4045] text-[#FDFBF7] px-4 py-2 rounded-full hover:bg-[#0a3237] transition-colors duration-200">
              <UserRound size={16} /> {t("nav.login")}
            </Link>
          )}
        </div>
      </div>
    </header>
  );
}
